import {gql} from '@apollo/client';
import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartLibrary from 'chemistry/ChemicalCounterpartLibrary';
import {createSolvate} from 'chemistry/ChemistryDAO';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {ErrorFragment} from 'graphql-client/Error';
import {TABLE_KEYS} from 'ui-library/scrollable/ScrollableTableConstants';

import {SolvateLibraryQuery} from './__generated/SolvateLibraryQuery';

export const SOLVATE_LIBRARY_QUERY = gql`
  query SolvateLibraryQuery @skipAudit @engComponent(name: CHEMISTRY) {
    solvates {
      id
      name
      code
      calculatedMolecularWeight
      canonicalSmiles
      imageData {
        ... on SVGNode {
          base64Svg
        }
        ...Error
      }
    }
  }
  ${ErrorFragment.fragment}
`;

export default function SolvateLibrary(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Solvates');
  }, []);

  const result = useBenchlingQuery<SolvateLibraryQuery>(SOLVATE_LIBRARY_QUERY);
  return (
    <ChemicalCounterpartLibrary
      itemName="solvate"
      items={result.type === QueryResultType.SUCCESS ? result.data.solvates : []}
      loading={result.type === QueryResultType.PENDING}
      tableKey={TABLE_KEYS.SOLVATE_LIBRARY_TABLE}
      onAddNew={async (name: string, code: string, sketcherValue: string) => {
        await createSolvate(name, sketcherValue, code || undefined);
        // Refetch GQL query to include new solvate in the results.
        await result.refetch();
      }}
    />
  );
}
